document.addEventListener('DOMContentLoaded', function () {
  const fileInputV1 = document.getElementById(
    'annual_report_ar_v1_q8_1_file_url'
  )
  const fileInputV3 = document.getElementById(
    'annual_report_ar_v3_q8_1_file_url'
  )

  const fileInput = fileInputV1 ? fileInputV1 : fileInputV3

  if (fileInput) {
    fileInput.addEventListener('click', function (event) {
      const div = document.getElementById('metrics-errors')
      if (div) {
        div.classList.add('visually-hidden')
      }
      this.value = null
    })

    fileInput.addEventListener('change', function (event) {
      if (event.target.files.length > 0) {
        const inProgressContainer = document.getElementById(
          'metrics-validation-in-progress'
        )
        const metricsError = document.getElementById('metrics-errors')
        const metricsValid = document.getElementById('metrics-valid')
        const serverErrorContainer = document.getElementById('server-errors')

        inProgressContainer.classList.remove('visually-hidden')
        serverErrorContainer.classList.add('visually-hidden')

        var csrfToken = document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content')

        var formData = new FormData()
        formData.append('file', event.target.files[0])

        var form = $(fileInput).closest('form')
        form.find(':submit').prop('disabled', true)

        var accountId = document.getElementById('account_id').value
        var url = '/reporting-centre/accounts/' + accountId
        if (fileInputV3) {
          url += '/v3'
        }
        url += '/annual_reports/validate_metrics'

        fetch(url, {
          headers: {
            'X-CSRF-Token': csrfToken,
          },
          method: 'POST',
          body: formData,
          credentials: 'include',
        })
          .then(async (response) => {
            let errorMessage = `${response.status} ${response.statusText}`
            let responseData

            try {
              responseData = await response.json()
            } catch (jsonError) {
              console.warn(
                'Failed to parse error response JSON:',
                jsonError.message
              )
            }

            if (!response.ok) {
              if (responseData && responseData.server_error) {
                errorMessage = responseData.server_error
                throw new Error(errorMessage)
              }
              if (responseData && responseData.validation_errors) {
                return { validation_errors: responseData.validation_errors }
              }

              throw new Error(errorMessage)
            }

            return responseData
          })
          .then((data) => {
            inProgressContainer.classList.add('visually-hidden')
            if (serverErrorContainer) {
              serverErrorContainer.classList.add('visually-hidden')
              serverErrorContainer.innerHTML = ''
            }

            if (data.validation_errors) {
              const errorContainer = document.getElementById(
                'metrics-errors-list'
              )
              errorContainer.innerHTML = ''

              metricsError.classList.remove('visually-hidden')
              metricsValid.classList.add('visually-hidden')

              form.find(':submit').prop('disabled', true)

              data.validation_errors.forEach((error) => {
                const listItem = document.createElement('li')
                listItem.textContent = error
                errorContainer.appendChild(listItem)
              })
            } else {
              metricsError.classList.add('visually-hidden')
              metricsValid.classList.remove('visually-hidden')

              form.find(':submit').prop('disabled', false)
            }
          })
          .catch((error) => {
            console.error('Error during fetch:', error)
            inProgressContainer.classList.add('visually-hidden')
            metricsError.classList.add('visually-hidden')
            metricsValid.classList.add('visually-hidden')

            if (serverErrorContainer) {
              serverErrorContainer.classList.remove('visually-hidden')
              serverErrorContainer.innerHTML =
                '<span class="field--error-text">There has been an error, please refresh the page and try uploading the PMU file again.</span>'
            }

            if (typeof Bugsnag !== 'undefined' && Bugsnag.notify) {
              Bugsnag.notify(error, (event) => {
                event.severity = 'error'
                event.context =
                  'reporting_centre/base_annual_reports#validate_metrics'
                event.errors[0].errorClass = 'PMU Upload'
                event.addMetadata('request', {
                  url: window.location.href,
                  method: 'POST',
                  endpoint: url,
                  csrfToken: csrfToken,
                  statusText: error.message,
                })
              })
            }
          })
      } else {
        console.log('No file selected')
      }
    })
  } else {
    console.log('File input element not found')
  }
})
